import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../../../pdc-platform/src/ts/Glob';
import { IValuesCollection } from '../ts/appTheme';
import { ITimeZone } from '../ts/DateTimeFunctions';
import { ParameterField } from './ParameterField';
import { IParameterFieldBaseOptions } from '../ts/ParameterFieldBase';
import TimeZonesListField, { BROWSER_DEFAULT } from './TimeZonesListField';
//import { validators } from '../ts/validators';

// function validateCustomString(strCustom) {
//     const errors = [];

//     if (!/^[+-](00|[0-9]|0[0-9]|1[0-6]):([0-5][0-9])$/g.exec(strCustom)) {
//         errors.push('Invalid input string. Use one like: "+08:30", "-2:00"; hours should not be more 16');
//     }

//     return errors;
// }

interface IEditUtcOffsetDialogOptions {
    timeZone: ITimeZone;
    theme: IValuesCollection;

    onChange(value: string[]): void;
}

interface IEditUtcOffsetDialogProperties {
    options?: IEditUtcOffsetDialogOptions;
    glob: IGlob;
}

function EditUtcOffsetDialog(props: IEditUtcOffsetDialogProperties) {
    const [offsetName, setOffsetName] = React.useState<string[]>(
        props.options.timeZone?.offsetName != null ? [props.options.timeZone.offsetName] : [BROWSER_DEFAULT]
    );
    // constructor(props) {
    //     super(props);

    //     state = _.extend(
    //         {
    //             value: fixedOffsetName,
    //             offsetName: new SuggestionSelectField(props.glob, 'Time Zone', [validators.string.notEmpty], '', {
    //                 allowNull: false,
    //                 values: [],
    //                 displayValues: [],
    //                 singleSelectMode: true,
    //                 theme: props.options.theme,

    //                 onChange: (values) => {
    //                     if (values == null) {
    //                         return null;
    //                     }

    //                     const offsetName = values['offsetName'];

    //                     if (offsetName != null) {
    //                         values['offsetName'] = _.map<ISuggestionValue, any>(offsetName, (value) => {
    //                             return value.value;
    //                         });
    //                     }

    //                     return values;
    //                 }
    //             })
    //         },
    //         getDefaultState()
    //     );
    // }

    const handleOnChange = (value: string[]) => {
        setOffsetName(value);
        props.options?.onChange(value);
    };

    return (
        <div className="widget-parameters-edit">
            <ParameterField title={'Time Zone'}>
                <TimeZonesListField
                    value={offsetName}
                    singleSelectMode={true}
                    allowNull={false}
                    theme={props.options.theme}
                    glob={props.glob}
                    onChange={handleOnChange}
                />
            </ParameterField>
        </div>
    );
}

interface IState {
    timeZone: ITimeZone;
    dlgOffsetName: string;
    dlgCustomString: string;
}

function getDefaultState(): IState {
    return {
        timeZone: {
            useOffset: false,
            offsetName: BROWSER_DEFAULT,

            useCustom: false,
            customString: '+00:00',
            customMinutes: 0
        },
        dlgOffsetName: 'none',
        dlgCustomString: 'none'
    };
}

export default function UtcOffsetField(props: {
    value?: ITimeZone;
    options?: IParameterFieldBaseOptions;
    glob: IGlob;

    onChange?(value: ITimeZone): void;
}) {
    const state = React.useMemo<IState>(() => {
        return {
            ...getDefaultState(),
            timeZone: props.value || {}
        };
    }, []);
    const [, setUpdateKey] = React.useState({});

    React.useEffect(() => {
        state.timeZone = props.value || {};
        setUpdateKey({});
    }, [props.value]);

    const handleOnClick = () => {
        showUtcOffsetDialog();
    };

    const editUtcOffsetDialogDo = () => {
        const def = $.Deferred();
        const { dlgOffsetName } = state;

        let newTimeZone: ITimeZone;

        //if (!isCustom) {
        if (dlgOffsetName === BROWSER_DEFAULT) {
            newTimeZone = {
                useOffset: false,
                offsetName: BROWSER_DEFAULT,

                useCustom: false,
                customString: '',
                customMinutes: 0
            };
        } else {
            newTimeZone = {
                useOffset: true,
                offsetName: dlgOffsetName,

                useCustom: false,
                customString: '',
                customMinutes: 0
            };
        }
        // } else {
        //     const dlgCustomString = state.current.dlgCustomString || '';
        //     const errors = validateCustomString(dlgCustomString);

        //     if (errors.length !== 0) {
        //         console.log(errors);
        //         return def;
        //     }

        //     const arr = dlgCustomString.split(':');
        //     const hBase = parseInt(arr[0]); //Math.abs(parseInt(arr[0]));
        //     const mBase = parseInt(arr[1]);

        //     let custMin = 0;

        //     if (hBase > 0) {
        //         custMin = -1 * (hBase * 60 + mBase);
        //     } else {
        //         custMin = -1 * (hBase * 60 - mBase);
        //     }

        //     newTimeZone = {
        //         useOffset: false,
        //         offsetName: '',

        //         useCustom: true,
        //         customString: dlgCustomString,
        //         customMinutes: custMin
        //     };
        // }

        state.timeZone = newTimeZone;

        if (typeof props.onChange === 'function') {
            const result = { ...newTimeZone };

            //EVG: Clean it up.
            if (!result.useCustom) {
                delete result.useCustom;
                delete result.customMinutes;
                delete result.customString;
            }

            props.onChange(result);
        }

        def.resolve();
        return def;
    };

    const handleOnTimeZoneChange = (values: string[]) => {
        if (values == null) {
            return;
        }

        state.dlgOffsetName = values[0];
        //state.current.dlgCustomString = values.customString;
    };

    const showUtcOffsetDialog = () => {
        const { timeZone } = state;

        let valueString = BROWSER_DEFAULT;
        let dlgTitle = '';

        if (timeZone.useOffset) {
            valueString = timeZone.offsetName;

            if (valueString === 'default') {
                valueString = BROWSER_DEFAULT;
            }
        }

        dlgTitle = 'Select Time Zone from the list';

        state.dlgCustomString = valueString;
        state.dlgOffsetName = valueString;

        props.glob.DialogActions.createDialogCustom<IEditUtcOffsetDialogOptions, any, any>(
            dlgTitle,
            () => {
                return editUtcOffsetDialogDo();
            },
            () => {},
            () => {},
            {
                deny: false,
                confirmTitle: 'Select',
                componentOptions: {
                    timeZone: timeZone,
                    theme: props.options?.theme,
                    onChange: handleOnTimeZoneChange
                },
                Component: EditUtcOffsetDialog
            }
        );
    };

    const value = state.timeZone;

    let valueString = BROWSER_DEFAULT;
    let isEtcGMT = false; //LL: 23.10.23

    if (value.useOffset) {
        valueString = value.offsetName;

        if (valueString === 'default') {
            valueString = BROWSER_DEFAULT;
        } else {
            isEtcGMT = valueString.startsWith('Etc/GMT'); //LL: 23.10.23
        }
    } else if (value.useCustom) {
        valueString = value.customString;
    }

    let warningEtcGMT: React.JSX.Element;

    if (isEtcGMT) {
        //LL: 05.10.23: add explanation-warning
        // See comment in DateTimeFunctions.ts function getOffsetInMinutes
        const pStyle: React.CSSProperties = { maxWidth: 'none', marginBottom: '0px' }; //05.10.23
        const pStyleSample: React.CSSProperties = { maxWidth: 'none', marginBottom: '0px', marginLeft: '10px' }; //05.10.23
        const pStyleUnderline: React.CSSProperties = {
            maxWidth: 'none',
            marginBottom: '0px',
            textDecoration: 'underline'
        };

        warningEtcGMT = (
            <div>
                <p style={pStyle}>Please pay attention and be carefull:</p>
                <p style={pStyle}>
                    Zone names beginning with "Etc/GMT" ("fixed-offset identifiers") have their offset sign reversed
                    from the standard ISO 8601 convention.
                </p>
                <p style={pStyle}>
                    In the "Etc" area, zones west of GMT have a positive sign and those east have a negative sign in
                    their name (e.g "Etc/GMT-4" is 4 hours ahead of GMT).
                </p>
                <p style={pStyle}>
                    For example, using the "Europe/Madrid" identifier gives a different offset result from "Etc/GMT+1":
                </p>
                <p style={pStyleSample}>tz('Etc/GMT+1').format('YYYY-MM-DD HH:mm ZZ') =&gt; '2014-12-18 11:22 -0100'</p>
                <p style={pStyleSample}>
                    tz('Europe/Madrid').format('YYYY-MM-DD HH:mm ZZ') =&gt; '2014-12-18 13:22 +0100'
                </p>
                <br />
                <a href="https://github.com/eggert/tz/blob/2017b/etcetera#L36-L42">
                    We use IANA's Time Zone Database, read more here
                </a>
                <br />
                <br />
                <p style={pStyleUnderline}>
                    It is highly recommended to avoid using Time Zones like "Etc/GMT-4" ("fixed-offset identifiers"),
                    such Time Zones don't use Summer/Winter time changes.
                </p>
            </div>
        );
    }

    const cellStyle: React.CSSProperties = {
        padding: '0px'
    };

    return (
        <div className="utc-offset-field">
            {warningEtcGMT}

            <table className={'table-borderless w-100'}>
                <tbody>
                    <tr>
                        <td className="value-cell" style={cellStyle}>
                            <input
                                readOnly={true}
                                type="text"
                                className="form-control"
                                value={valueString}
                                onClick={handleOnClick}
                            />
                        </td>

                        <td className="browse-cell" style={{ ...cellStyle, width: '2rem' }}>
                            <button
                                className="btn btn-default"
                                title={'Select from list'}
                                style={{
                                    margin: '0px'
                                }}
                                onClick={handleOnClick}
                            >
                                <span className="glyphicon glyphicon-search"></span>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
